import OffersRepository from '~repositories/OffersRepository/OffersRepository';
import { diContainer } from '~setup/diContainer';
import { serviceNames } from '~setup/OffersService';
import { OffersEnum } from '~utils/OffersEnum';
import { GlobalServiceBus } from '@estee/elc-service-bus';

interface IFetchedOffersByViewsUseCase {
    views: string[];
}

export default class FetchedOffersByViewsUseCase {
    private offersRepository: OffersRepository;
    private views: string[];

    constructor({ views }: IFetchedOffersByViewsUseCase) {
        this.views = views;
        this.offersRepository = diContainer.get(serviceNames.offersRepository);
    }

    private setOffersState = (state: 'isLoading' | 'hasError', value: boolean) => {
        this.views.map((view) => {
            const offerType = OffersEnum[view as keyof typeof OffersEnum];
            this.offersRepository.cartOffers[offerType][state] = value;
        });
    };

    public execute = async () => {
        try {
            this.setOffersState('isLoading', true);
            await this.offersRepository.fetchOffersByViews(this.views);
        } catch (e) {
            this.setOffersState('hasError', true);
            GlobalServiceBus.log({
                message: 'Failed to fetch the cart',
                payload: { error: e }
            });
        } finally {
            this.setOffersState('isLoading', false);
            this.offersRepository.notifyServices();
        }
    };
}
